module.exports = __webpack_public_path__ + "img/setting.d9eadd4e.svg";